import { BusinessObjectPart, BusinessObjectPartContext, ModelBase, Weaver } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';
import { addDays, dateDiffInDays, withFlag } from '@skylab-shared/utils';
import { propertyChangedFilter } from '../../common/property-changed/property-changed-filter';
import { DueDateBeforeIssueDateError } from '../violations/due-date-before-issue-date-error';

interface DocumentModelPart extends ModelBase {
    dueDate: Date;
    dueDateInDays: number;
    issueDate: Date;
}

export class SaleDocumentWithDueDateBoPart extends BusinessObjectPart<DocumentModelPart> {

    public constructor(weaver: Weaver) {
        super(weaver);
    }

    public override async initializeAsync(context: BusinessObjectPartContext<DocumentModelPart>): Promise<void> {
        await super.initializeAsync(context);

        const modelType = <Constructor<DocumentModelPart>> this.bo.model.constructor;

        this.engine.validation.addRule(
            [[modelType, 'issueDate'], [modelType, 'dueDate']],
            [[modelType, 'dueDate']],
            ctx => dateDiffInDays(ctx.source.dueDate, ctx.source.issueDate) >= 0,
            DueDateBeforeIssueDateError
        );

        this.coreFeature.propertyChanged.listen<DocumentModelPart>(propertyChangedFilter(
            modelType,
            ['dueDate', 'dueDateInDays', 'issueDate'],
            ctx => {
                withFlag(() => {
                    this.calculateDueDate(ctx.model, ctx.propertyName);
                }, 'due-date-calculation');
            }
        ));
    }

    private calculateDueDate(document: DocumentModelPart, updatedProperty: keyof DocumentModelPart): void {
        if (updatedProperty === 'dueDate') {
            document.dueDateInDays = dateDiffInDays(document.dueDate, document.issueDate);
        } else if (['dueDateInDays', 'issueDate'].includes(updatedProperty)) {
            document.dueDate = addDays(document.issueDate, document.dueDateInDays);
        }
    }
}
